/**
 This wrapper is used to render the Order 
 component with the orderReferenceId from the URL 
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import Order from '../app/order';

const OrderWrapper = (props) => {
    const { orderReferenceId } = useParams();
    return <Order {...props} orderReferenceId={orderReferenceId} />;
};

export default OrderWrapper;
